import { render, staticRenderFns } from "./Summation.vue?vue&type=template&id=2595c0ea&"
import script from "./Summation.vue?vue&type=script&lang=js&"
export * from "./Summation.vue?vue&type=script&lang=js&"
import style0 from "./Summation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports